<div class="main">
  <div class="header"  [ngStyle]="{'background-color':(parentData.type==0)? '#631d4f':'#631d4f'}">
    <span>{{parentData.heading}}</span>
    <!-- <span *ngIf="parentData.type == 0 || parentData.type == 1" style="margin-left: 3%;border-left: dashed 1px #fff;padding-left: 1%;"> Total : {{parentData.count}}</span> -->
    <i class="material-icons" (click)="closeModal();">clear</i>
    <!-- <i *ngIf="parentData.type==1" class="material-icons dashIcon" (click)="openDashboard($event, 'live', 'acceptance')">launch</i> -->
   <!--  <i *ngIf="parentData.type==2" class="material-icons dashIcon" (click)="openDashboard($event, 'live', 'assignment')">launch</i> -->
  </div>
  <div class="section">

    <div class="body">

      <div class="cardSection" *ngIf="parentData.type == 0">
        
        <div class="tableSection">

          <table mat-table *ngIf="utilizationData.length;else noUtilizeData" [dataSource]="utilizationData" class="table">
  
            <ng-container matColumnDef='shipper'>
              <th mat-header-cell *matHeaderCellDef> {{'postShipment.shipper' | translate}}</th>
              <td mat-cell *matCellDef="let element"> {{element._id || 'N/A'}} </td>
            </ng-container>
  
            <ng-container matColumnDef='vehicle'>
              <th mat-header-cell *matHeaderCellDef> {{'postShipment.vehicle' | translate}}</th>
              <td mat-cell *matCellDef="let element"> {{element.no_of_shipments || 'N/A'}} </td>
            </ng-container>
  
            <tr mat-header-row *matHeaderRowDef="utilizeHeaders; sticky: true;"></tr>
                        <tr mat-row *matRowDef="let myRowData; columns: utilizeHeaders"></tr>
          </table>
        </div>

        <ng-template #noUtilizeData>
          <div class="noUtilizeData" style="padding-top: 30px; text-align: center; color:#D8511F">
            {{'postShipment.noData' | translate}}
          </div>
        </ng-template>

      </div>

      <div class="cardSection" *ngIf="parentData.type == 1">
        <div class="tableSection">
          <table mat-table *ngIf="ePodData.length;else noUtilizeData" [dataSource]="ePodData" class="table">
  
            <ng-container matColumnDef='shipment'>
              <th mat-header-cell *matHeaderCellDef> {{'postShipment.shipmentId' | translate}} </th>
              <td mat-cell *matCellDef="let element"> {{element.SIN || 'N/A'}} </td>
            </ng-container>
  
            <ng-container matColumnDef='driver'>
              <th mat-header-cell *matHeaderCellDef> {{'postShipment.driver' | translate}} </th>
              <td mat-cell *matCellDef="let element">
                <div> {{ (element.driver && element.driver.name) ?  element.driver.name : 'N/A'}} </div>
                <div> {{ (element.driver && element.driver.mobile) ?  countryCode + element.driver.mobile : 'N/A'}} </div>
              </td>
            </ng-container>
  
            <ng-container matColumnDef='locs'>
              <th mat-header-cell *matHeaderCellDef> {{'postShipment.deliveryLocation' | translate}} </th>
              <td mat-cell *matCellDef="let element" style="padding: 2%;">
                <div style="display: flex;">
                  <div style="text-align: left;width: 50%; font-weight: bold;">
                    {{element.location.name || 'N/A'}}
                  </div>
                  <div style="text-align: right;width: 50%;">
                    {{ (element.delivery && element.delivery.finished_at) ? getDate(element.delivery.finished_at) : 'N/A'}}
                  </div>
                </div>
                <!-- <div>  </div> -->
                <div style="float: left;"> {{element.location.area || 'N/A'}} </div>
              </td>
            </ng-container>
  
            <tr mat-header-row *matHeaderRowDef="epodHeaders; sticky: true;"></tr>
                        <tr mat-row *matRowDef="let myRowData; columns: epodHeaders"></tr>
          </table>
        
        </div>

        <ng-template #noUtilizeData>
          <div class="noUtilizeData" style="padding-top: 30px; text-align: center; color:#D8511F">
            {{'postShipment.noData' | translate}}
          </div>
        </ng-template>

      </div>
    </div>
  </div>
</div>